import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next';
import { isMobileContext } from '../context/isMobileContext';
import { Tabs, TabPanel, TabList, Tab } from "react-tabs";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/free-mode";
import { Navigation } from "swiper";
import { motion } from "framer-motion";
import AwardsCard from './AwardsCard';
import i18n from '../../i18n';
const Awards = () => {
  const { t, i18n } = useTranslation();
  const { isMobile } = useContext(isMobileContext);
  const awardsData = [
    {
      tab: {
        name: 2019,
        tabData: [
          {
            text: t("awardsAppendices.c1"),
            img: '/imgs/appendices/Award-1.svg',
          }, {
            text: t("awardsAppendices.c2"),
            img: '/imgs/appendices/Award-2.svg'
          }, {
            text: t("awardsAppendices.c3"),
            img: '/imgs/appendices/Award-3.svg'
          }, {
            text: t("awardsAppendices.c4"),
            img: '/imgs/appendices/Award-4.svg'
          }, {
            text: t("awardsAppendices.c5"),
            img: '/imgs/appendices/Award-5.svg'
          }, {
            text: t("awardsAppendices.c6"),
            img: '/imgs/appendices/Award-6.svg'
          }, {
            text: t("awardsAppendices.c7"),
            img: '/imgs/appendices/Award-7.svg'
          }, {
            text: t("awardsAppendices.c8"),
            img: '/imgs/appendices/Award-8.svg'
          }, {
            text: t("awardsAppendices.c9"),
            img: '/imgs/appendices/Award-9.svg'
          }, {
            text: t("awardsAppendices.c10"),
            img: '/imgs/appendices/Award-10.svg'
          },
        ]
      }
    },
    {
      tab: {
        name: 2020,
        tabData: [
          {
            text: t("awardsAppendices.c2020_1"),
            img: '/imgs/appendices/Award-2020-1.svg',
          }, {
            text: t("awardsAppendices.c2020_2"),
            img: '/imgs/appendices/Award-2020-2.svg'
          }, {
            text: t("awardsAppendices.c2020_3"),
            img: '/imgs/appendices/Award-2020-3.svg'
          }, {
            text: t("awardsAppendices.c2020_4"),
            img: '/imgs/appendices/Award-2020-4.svg'
          },
        ]
      }
    },
    {
      tab: {
        name: 2021,
        tabData: [
          {
            text: t("awardsAppendices.c2021_1"),
            img: '/imgs/appendices/Award-2021-1.svg',
          }, {
            text: t("awardsAppendices.c2021_2"),
            img: '/imgs/appendices/Award-2021-2.svg'
          }, {
            text: t("awardsAppendices.c2021_3"),
            img: '/imgs/appendices/Award-2021-3.svg'
          }, {
            text: t("awardsAppendices.c2021_4"),
            img: '/imgs/appendices/Award-2021-4.svg'
          }, {
            text: t("awardsAppendices.c2021_5"),
            img: '/imgs/appendices/Award-2021-5.svg'
          }, {
            text: t("awardsAppendices.c2021_6"),
            img: '/imgs/appendices/Award-2021-6.svg'
          }, {
            text: t("awardsAppendices.c2021_7"),
            img: '/imgs/appendices/Award-2021-7.svg'
          },
        ]
      }
    },

  ]
  return (
    <div className='awards-section'>
      <div className='first-bg'>
        <img
          src={process.env.PUBLIC_URL + '/imgs/appendices/awards-bg.png'}
          alt='background'
        />
      </div>  
      <div className='first-bg second'>
        <img
          src={process.env.PUBLIC_URL + '/imgs/appendices/awards-bg2.png'}
          alt='background'
        />
      </div>
      <div className="title">
        <motion.h2
          initial={{ opacity: 0, translateY: "70%" }}
          whileInView={{ opacity: 1, translateY: 0 }}
          viewport={{ once: true }}
          transition={{ ease: "easeInOut", delay: isMobile ? 0.1 : 0.2, duration: 0.5 }}
        >
          {t("awardsAppendices.headLine")}
        </motion.h2>
      </div>
      <Tabs defaultIndex={2}>
        <TabList>
          {awardsData.map((tab, index) => (
            <Tab key={index}>
              <motion.div
                initial={{ opacity: "0", }}
                whileInView={{ opacity: 1 }}
                viewport={{ once: true }}
                transition={{ delay: parseFloat((index / 5) + 0.3), duration: .5 }}
                key={index}>
                <span>{tab.tab.name}</span>
              </motion.div>
            </Tab>
          ))}
        </TabList>
        <div className='panels-container'>
          <div className='union-bg'>
            <img
              src={process.env.PUBLIC_URL + "/imgs/appendices/union-bg.svg"}
              alt="union-bg"
            />
          </div>
          {awardsData?.map((tab, tabIndex) => (
            <TabPanel key={tabIndex}>
              <Swiper
                key={"awards"+tab.name+i18n.language}
                modules={[Navigation]}
                style={{ direction: i18n.language === "ar" ? "rtl" : "ltr" }}
                navigation={{
                  nextEl: ".awards-next",
                  prevEl: ".awards-prev",
                }}
                className={`swiper-awards-section ${tabIndex===1&&"second-swiper"}`}
                slidesPerView={1}
                spaceBetween={0}
                breakpoints={{
                  768: {
                    slidesPerView: 3,
                    spaceBetween: 0,
                  },
                  1024: {
                    slidesPerView: 5,
                    spaceBetween: 0,
                  },
                }}
              >
                {tab?.tab?.tabData?.map(
                  (data, index) => (
                    <SwiperSlide key={index}>
                      <AwardsCard
                        key={index}
                        index={index}
                        img={process.env.PUBLIC_URL + data.img}
                        text={data.text}
                        tabIndex={tabIndex}
                      />
                    </SwiperSlide>
                  )
                )}
              </Swiper>
              <motion.div
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                viewport={{ once: true }}
                transition={{
                  ease: "easeInOut",
                  delay: .6,
                  duration: 0.5,
                }}
                className={`awards-navigation-container
                ${isMobile && tab.tab.tabData.length === 1 && "d-none"}
                ${!isMobile && tab.tab.tabData.length < 5 && "d-none"}
                `}>
                <div className="swiper-button-prev awards-prev"></div>
                <div className="swiper-button-next awards-next"></div>
              </motion.div>
            </TabPanel>
          ))}
        </div>
      </Tabs>
    </div>
  )
}

export default Awards
